import { CommissionsIcon, DashboardIcon, navIconNode, SettingsIcon } from '@/components/icons';
import { useAuth } from '@/contexts/auth-context';
import { Box, Text, VStack } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { TOP_BAR_HEIGHT } from '../layout/TopBar';
import { useIsMobileLayout } from '../layout/nav-dark';
import NavLink from '../nav-bar/nav-link';
import { SIDEBAR_WIDTH } from './PrimarySidebar';

/** Presentation only: no counters or business readers while billing approval is unresolved. */
export function BillingLimitedSidebar({ bannerHeight = 0 }: { bannerHeight?: number }) {
  const { t } = useTranslation();
  const { user } = useAuth();
  const isMobile = useIsMobileLayout();
  if (isMobile) return null;
  return (
    <Box
      as="nav"
      position="fixed"
      top={`${TOP_BAR_HEIGHT + bannerHeight}px`}
      left={0}
      bottom={0}
      w={`${SIDEBAR_WIDTH}px`}
      color="navDark.text"
      px={3}
      pt={4}
      zIndex="sticky"
    >
      <Text px="10px" mb={5} fontWeight="semibold" truncate>
        {user?.currentBrand?.name}
      </Text>
      <VStack align="stretch" gap="1px">
        <NavLink
          to="/dashboard"
          label={t('navigation.dashboard')}
          icon={navIconNode(DashboardIcon)}
        />
        <NavLink
          to="/payments/commissions"
          label={t('navigation.commissions')}
          icon={navIconNode(CommissionsIcon)}
        />
        <NavLink
          to="/settings/billing"
          label={t('navigation.settings')}
          icon={navIconNode(SettingsIcon)}
        />
      </VStack>
    </Box>
  );
}
